// extracted by mini-css-extract-plugin
module.exports = {"helpCenter":"HelpCenter_helpCenter__2QTIJ","helpCenterContainer":"HelpCenter_helpCenterContainer__1n7zV","animationContainer":"HelpCenter_animationContainer__2ldYG"};